
export const GameProtocolMetadata = {
    version: 5,
};
